import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiUser, FiMenu, FiX } from 'react-icons/fi';
import { FaCalendarAlt, FaMoneyBill, FaListOl, FaBriefcase } from 'react-icons/fa';
import { CiLogout } from 'react-icons/ci';
import { VscFeedback, 
  // VscGraphLine 
} from "react-icons/vsc";
import firebase from "firebase/app";
import "firebase/auth";
import { MdManageAccounts } from 'react-icons/md';

const menuItems = [
  { name: 'Dashboard', icon: <FiHome />, path: '/dashboard' },
  { name: 'Sessions', icon: <FaListOl />, path: '/sessions' },
  { name: 'Job analysis and CV Tools', icon: <FaBriefcase />, path: '/job-analysis' },
  // { name: 'Improvement Plan', icon: <VscGraphLine />, path: '/improvement-plan' },
  { name: 'Calendar', icon: <FaCalendarAlt />, path: '/calendar' },
  { name: 'Billings', icon: <FaMoneyBill />, path: '/billing' },
  { name: 'Profile', icon: <FiUser />, path: '/profile' },
  { name: 'Account', icon: <MdManageAccounts />, path: '/account' },
  { name: 'User Feedback', icon: <VscFeedback />, path: '/help' },
];

interface NewSidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const NewSidebar = ({ isOpen, toggleSidebar }: NewSidebarProps) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // Toggles the mobile menu open/closed
  const toggleMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  // Handle logout
  const handleLogout = () => {
    firebase.auth().signOut().then(() => {
      window.location.reload();
    });
  };

  return (
    <>
      {/* 
        Mobile menu button (hamburger icon) - 
        Visible only for screens below the 'lg' breakpoint 
      */}
      <div className="lg:hidden flex items-center p-4 bg-blue-800 text-white">
        <button onClick={toggleMobileMenu} className="focus:outline-none">
          <FiMenu size={24} />
        </button>
      </div>

      {/* Overlay for mobile menu */}
      {showMobileMenu && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10 lg:hidden"
          onClick={toggleMobileMenu}
        ></div>
      )}

      {/* Sidebar container */}
      <div
        className={`
          fixed top-0 left-0 h-full
          bg-blue-900 text-white flex flex-col
          z-20
          transform transition-all duration-300 ease-in-out
          ${isOpen || showMobileMenu ? "w-64" : "w-16"}
          ${showMobileMenu ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        {/* Sidebar Header */}
        <div className="flex items-center justify-between p-4">
          <h1
            className={`
              text-xl font-bold truncate
              transition-all duration-300
              ${(!isOpen && !showMobileMenu) ? "opacity-0" : "opacity-100"}
            `}
          >
            PrepBestie
          </h1>

          {/* Right-aligned header buttons */}
          <div className="flex items-center space-x-2">
            {/* Desktop toggle button (visible on lg and up) */}
            <button
              className="hidden lg:block focus:outline-none"
              onClick={toggleSidebar}
            >
              <FiMenu size={24} />
            </button>

            {/* Mobile close button (visible below lg) */}
            {showMobileMenu && (
              <button
                className="lg:hidden focus:outline-none"
                onClick={toggleMobileMenu}
              >
                <FiX size={24} />
              </button>
            )}
          </div>
        </div>

        {/* Menu Items */}
        <nav className="flex-1 px-2 space-y-2">
          {menuItems.map((item) => (
            <Link
              to={item.path}
              key={item.name}
              onClick={() => setShowMobileMenu(false)}
              className={`
                flex items-center p-2 text-gray-300 
                hover:bg-gray-800 rounded transition-colors
                ${(!isOpen && !showMobileMenu) ? 'justify-center' : ''}
              `}
            >
              <div className="text-xl">{item.icon}</div>
              <span
                className={`
                  ml-3 text-sm font-medium 
                  whitespace-nowrap
                  ${(!isOpen && !showMobileMenu) ? 'hidden' : ''}
                `}
              >
                {item.name}
              </span>
            </Link>
          ))}
        </nav>

        {/* Sidebar Footer / Logout */}
        <div className="p-4 cursor-pointer" onClick={handleLogout}>
          <div
            className={`
              flex items-center 
              ${(!isOpen && !showMobileMenu) ? 'justify-center' : ''}
            `}
          >
            <CiLogout className="text-xl" />
            <span
              className={`
                ml-3 text-sm font-medium
                ${(!isOpen && !showMobileMenu) ? 'hidden' : ''}
              `}
            >
              Logout
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewSidebar;
